import type { AfterViewInit, ElementRef } from '@angular/core';
import {
  Component,
  Injector,
  effect,
  inject,
  input,
  model,
  viewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { I18N_NAMESPACE } from '../../../internal/constants';
import { OnyxClearButtonComponent } from '../../buttons/onyx-clear-button/onyx-clear-button.component';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import { OnyxSpinnerComponent } from '../../spinner/onyx-spinner/onyx-spinner.component';

@Component({
  selector: 'onyx-search',
  imports: [
    OnyxIconComponent,
    TranslatePipe,
    OnyxClearButtonComponent,
    OnyxSpinnerComponent,
  ],
  templateUrl: './onyx-search.component.html',
  styleUrl: './onyx-search.component.scss',
  host: { '[style.width]': `width()` },
})
export class OnyxSearchComponent implements AfterViewInit {
  private readonly injector = inject(Injector);

  public readonly query = model<string>();
  public readonly placeholder = input<string | null>(null);
  public readonly color = input<'dark-gray' | 'light-gray' | 'white'>(
    'dark-gray',
  );
  public readonly showFocus = input(true);
  public readonly loading = input(false);
  public readonly size = input<32 | 40>(40);
  public readonly width = input('auto');

  protected readonly I18N = `${I18N_NAMESPACE}.search`;

  private searchElementRef =
    viewChild.required<ElementRef<HTMLInputElement>>('searchElement');

  public ngAfterViewInit(): void {
    effect(
      () => (this.searchElementRef().nativeElement.value = this.query() ?? ''),
      { injector: this.injector },
    );
  }

  public focus(): void {
    this.searchElementRef().nativeElement.focus();
  }

  protected changeValue(event: Event): void {
    this.query.set((event.target as HTMLInputElement).value);
  }

  protected clearValue(): void {
    this.query.set('');
    this.focus();
  }
}
